import {useMemo} from "react";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {DistrictData} from "../api/fetch_districts_monthly_stats";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {PricesViewType} from "../helpers/prices_view_type";
import {DistrictRow} from "../types/DistrictRow";
import {formatMonthLabel} from "./format_month_label";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getDistrictDisplayData} from "./get_district_display_data";
import {CURRENT_MONTHS_EARLIER, MAX_BIGDATA_MONTHS_EARLIER, useDistrictsPriceData} from "./use_districts_price_data";

export const useDistrictRows = (region: IRegionReportPrice, type: PricesViewType, rooms: RoomsFilter) => {
    const {districtRegions, districtData, referenceDate, isLoading} = useDistrictsPriceData(region, type);

    const currentMonthDateStart = getMonthDateStart(CURRENT_MONTHS_EARLIER, referenceDate);
    const yearAgoMonthDateStart = getMonthDateStart(MAX_BIGDATA_MONTHS_EARLIER, referenceDate);

    // The rooms filter only picks another price column from the same BigData rows - no request, just a recompute.
    const districts = useMemo(() => {
        if (!districtRegions || !districtData) {
            return null;
        }

        return buildRows(districtRegions, indexDistrictData(districtData), currentMonthDateStart, yearAgoMonthDateStart, rooms, region.slug);
    }, [districtRegions, districtData, currentMonthDateStart, yearAgoMonthDateStart, rooms, region.slug]);

    return {
        districts,
        dateLabel: districts ? formatMonthLabel(currentMonthDateStart) : undefined,
        yearAgoDateLabel: districts ? formatMonthLabel(yearAgoMonthDateStart) : undefined,
        isLoading
    };
};

const getMonthDateStart = (monthsEarlier: number, referenceDate: Date): string => getFetchQueryDataMonth(monthsEarlier, referenceDate).date_start;

// Keyed by "date|slug_district" - O(1) lookup of any district's data for any already-fetched month.
const indexDistrictData = (allDistrictData: DistrictData[]): Map<string, DistrictData> =>
    new Map(allDistrictData.map((item) => [`${item.date}|${item.slug_district}`, item]));

const buildRows = (
    districtRegions: IRegionReportPrice[],
    districtDataIndex: Map<string, DistrictData>,
    currentMonthDateStart: string,
    yearAgoMonthDateStart: string,
    rooms: RoomsFilter,
    citySlug: string
): DistrictRow[] =>
    districtRegions
        .map((districtRegion): DistrictRow | null => {
            const slugDistrict = getDistrictDisplayData(districtRegion, citySlug).slug;
            const currentData = districtDataIndex.get(`${currentMonthDateStart}|${slugDistrict}`);

            if (!currentData) {
                return null;
            }

            const yearAgoData = districtDataIndex.get(`${yearAgoMonthDateStart}|${slugDistrict}`);
            const offerPriceM2 = getAvgPriceM2ForRooms(currentData, rooms);
            const yearAgoOfferPriceM2 = yearAgoData ? getAvgPriceM2ForRooms(yearAgoData, rooms) : null;
            const yearOverYearPct =
                offerPriceM2 && yearAgoOfferPriceM2 ? Math.round(((offerPriceM2 - yearAgoOfferPriceM2) / yearAgoOfferPriceM2) * 1000) / 10 : null;

            return {
                id: districtRegion.id,
                slug: districtRegion.slug,
                name: currentData.district,
                offerPriceM2,
                yearAgoOfferPriceM2,
                yearOverYearPct
            };
        })
        .filter((row): row is DistrictRow => row !== null);
import {useMemo} from "react";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {DistrictData} from "../api/fetch_districts_monthly_stats";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {PricesViewType} from "../helpers/prices_view_type";
import {DistrictRow} from "../types/DistrictRow";
import {formatMonthLabel} from "./format_month_label";
import {getAvgPriceM2ForRooms} from "./get_avg_price_m2_for_rooms";
import {getDistrictDisplayData} from "./get_district_display_data";
import {CURRENT_MONTHS_EARLIER, MAX_BIGDATA_MONTHS_EARLIER, useDistrictsPriceData} from "./use_districts_price_data";

export const useDistrictRows = (region: IRegionReportPrice, type: PricesViewType, rooms: RoomsFilter) => {
    const {districtRegions, districtData, referenceDate, isLoading} = useDistrictsPriceData(region, type);

    const currentMonthDateStart = getMonthDateStart(CURRENT_MONTHS_EARLIER, referenceDate);
    const yearAgoMonthDateStart = getMonthDateStart(MAX_BIGDATA_MONTHS_EARLIER, referenceDate);

    // The rooms filter only picks another price column from the same BigData rows - no request, just a recompute.
    const districts = useMemo(() => {
        if (!districtRegions || !districtData) {
            return null;
        }

        return buildRows(districtRegions, indexDistrictData(districtData), currentMonthDateStart, yearAgoMonthDateStart, rooms, region.slug);
    }, [districtRegions, districtData, currentMonthDateStart, yearAgoMonthDateStart, rooms, region.slug]);

    return {
        districts,
        dateLabel: districts ? formatMonthLabel(currentMonthDateStart) : undefined,
        yearAgoDateLabel: districts ? formatMonthLabel(yearAgoMonthDateStart) : undefined,
        isLoading
    };
};

const getMonthDateStart = (monthsEarlier: number, referenceDate: Date): string => getFetchQueryDataMonth(monthsEarlier, referenceDate).date_start;

// Keyed by "date|slug_district" - O(1) lookup of any district's data for any already-fetched month.
const indexDistrictData = (allDistrictData: DistrictData[]): Map<string, DistrictData> =>
    new Map(allDistrictData.map((item) => [`${item.date}|${item.slug_district}`, item]));

const buildRows = (
    districtRegions: IRegionReportPrice[],
    districtDataIndex: Map<string, DistrictData>,
    currentMonthDateStart: string,
    yearAgoMonthDateStart: string,
    rooms: RoomsFilter,
    citySlug: string
): DistrictRow[] =>
    districtRegions
        .map((districtRegion): DistrictRow | null => {
            const slugDistrict = getDistrictDisplayData(districtRegion, citySlug).slug;
            const currentData = districtDataIndex.get(`${currentMonthDateStart}|${slugDistrict}`);

            if (!currentData) {
                return null;
            }

            const yearAgoData = districtDataIndex.get(`${yearAgoMonthDateStart}|${slugDistrict}`);
            const offerPriceM2 = getAvgPriceM2ForRooms(currentData, rooms);
            const yearAgoOfferPriceM2 = yearAgoData ? getAvgPriceM2ForRooms(yearAgoData, rooms) : null;
            const yearOverYearPct =
                offerPriceM2 && yearAgoOfferPriceM2 ? Math.round(((offerPriceM2 - yearAgoOfferPriceM2) / yearAgoOfferPriceM2) * 1000) / 10 : null;

            return {
                id: districtRegion.id,
                slug: districtRegion.slug,
                name: currentData.district,
                offerPriceM2,
                yearAgoOfferPriceM2,
                yearOverYearPct
            };
        })
        .filter((row): row is DistrictRow => row !== null);
